import type { RecipeDto } from '@iac/contracts';
import { fold } from '../../lib/fold';

/**
 * The recipes matching both filters. Every typed word must occur in the name,
 * an ingredient line or a tag — steps and notes are left out, since words like
 * "sól" or "piekarnik" are in nearly every recipe. Every picked tag must be on
 * the recipe. Case and Polish accents never matter.
 */
export function filterRecipes(
  recipes: readonly RecipeDto[],
  query: string,
  tags: readonly string[],
): RecipeDto[] {
  const words = fold(query).split(/\s+/).filter(Boolean);
  return recipes.filter((recipe) => {
    if (!tags.every((tag) => recipe.tags.includes(tag))) return false;
    if (words.length === 0) return true;
    const haystack = fold(
      [recipe.name, ...recipe.ingredients, ...recipe.tags].join('\n'),
    );
    return words.every((word) => haystack.includes(word));
  });
}

/** Every tag in use, A–Z, once — the chips and the tag input's suggestions. */
export function tagsInUse(
  recipes: readonly RecipeDto[],
  collator: Intl.Collator,
): string[] {
  return [...new Set(recipes.flatMap((r) => r.tags))].sort(collator.compare);
}
